import {Directive, ElementRef, HostListener, Input, OnInit} from '@angular/core';

@Directive({
    selector: '[mzMask]'
})
export class MzMaskDirective implements OnInit {

    @Input() mzMask: string;
    maskObject = {};
    maxLength;

    constructor(private el: ElementRef) {
    }

    ngOnInit() {
        this.maxLength = this.mzMask.length;
        for (let i = 0; i < this.mzMask.length; i++) {
            if (this.mzMask[i] !== '0') {
                this.maskObject[i] = this.mzMask[i];
            }
        }
    }

    @HostListener('keydown', ['$event']) keyUp(e) {
        const len = this.el.nativeElement.value.length;
        if (len === this.maxLength && e.key !== 'Backspace') {
            e.preventDefault();
            e.stopPropagation();
        }
        if (this.maskObject[len] && e.key !== 'Backspace') {
            e.preventDefault();
            e.stopPropagation();
            this.el.nativeElement.value = this.el.nativeElement.value + this.maskObject[len] + e.key;
        }
    }

}
